import { useUserData } from '@contexts/UserDataContext'
import { FaInfoCircle } from 'react-icons/fa'
import Tooltip from '../Tooltip/Tooltip'
import SegmentedToggle from './SegmentedToggle'

const DelayedStatsEntrySetting = () => {
  const { userData, updateUserData } = useUserData()

  return (
    <div className="flex justify-between items-center my-4 py-3 border-b border-main">
      <div className="flex items-center justify-items-start gap-1">
        <label htmlFor="delayedStatsEntry" className="font-bold text-main">
          İstatistik Kaydı Gecikmesi
        </label>
        <Tooltip content="İstatistik kaydı gecikmesi açık olduğunda, otomatik eklenen istatistik verileri saat gece 3:00'a kadar bir önceki günün istatistiklerine eklenir.">
          <FaInfoCircle className="text-muted" />
        </Tooltip>
      </div>
      <SegmentedToggle
        value={!!userData.delayedStatsEntry}
        onChange={(val) => updateUserData('delayedStatsEntry', val)}
      />
    </div>
  )
}

export default DelayedStatsEntrySetting
